module.exports = __webpack_public_path__ + "img/adv-mapIcon22.25df5287.png";